export default "__VITE_ASSET__CGNewiL8__"